<template>
  <div>
    <div class="detailsContain main" v-loading="loading" v-if="isPC">
      <div style="margin-top: 8px">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item class="fontfine" :to="{ path: '/order/list' }">{{ $t('orderDetail.MyOrder') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('orderDetail.OrderInformation') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="order-information">
        <h3>{{ $t('orderDetail.OrderInformation') }}</h3>
        <div class="f--c handleGroup">
          <!-- <el-button type="text" v-if="['waiting_to_ship', 'partial_shipped'].includes(showStatus) && !(detailObj.pays.paymentMethod === 8 && detailObj.orders.fulfillmentStatus === 'partial_shipped')" @click="handleRefund">{{ $t('orderDetail.ApplyRefund') }}</el-button> -->
          <el-button type="text" v-if="['waiting_to_ship', 'partial_shipped'].includes(showStatus) && detailObj.pays.paymentMethod !== 8" @click="handleRefund">{{ $t('orderDetail.ApplyRefund') }}</el-button>
          <el-button type="text" v-if="['waiting_payment', 'abnormal_order'].includes(showStatus)" @click="cancelOrder" class="link_button" >{{ $t('orderList.CancelOrder') }}</el-button>
          <template v-if="detailObj.orders.status !== 'abnormal_order'">
            <template v-if="detailObj.orders.refundStatus !== 'refunded'">
              <el-button type="text" @click="orderDownloadInvoice" v-if="!['waiting_payment', 'waiting_to_ship', 'cancel'].includes(showStatus)">{{ $t('Order.Details.Index.Invoice') }}</el-button>
            </template>
          </template>
        </div>
      </div>
      <div class="refund_reason bg-white f-b" v-if="detailObj.orders.refundStatus !== 'NULL'">
        <div style="color: #EB5757">
          <h3 style="font-size: 18px">{{ refundText }}</h3>
          <p v-if="detailObj.orders.refundReason" style="color: #4F4F4F">{{ `Refund Reason: ${detailObj.orders.refundReason || 'Refund Reason:显示的是用户提交的退款原因'}` }}</p>
        </div>
        <div>
          <el-button style="height: 44px;font-size: 16px" round @click="$refs.refundRecord.show(detailObj.orders.kkOrderId)">{{ $t('Order.Details.Index.RefundRecord') }}</el-button>
        </div>
      </div>
      <topTimeLine :detailObj="detailObj" @updateAddress="updateAddressShow" @updateDetail="updateDetail"></topTimeLine>
      <div class="f-b middle f--c">
        <div class="f id">
          <div v-if="!['Kakaclo', 'kakaclo'].includes(detailObj.orders.platformName)">{{ $t('orderDetail.StoreOrderID') }}: {{ detailObj.orders.orderId }}</div>
          <div>{{ $t('orderDetail.OrderID') }}: {{ detailObj.orders.kkOrderId }}</div>
          <div>{{ $t('orderDetail.Source') }}: {{ `${detailObj.orders.platformName}  ${detailObj.orders.storeName || ''}` }}</div>
          <div>{{ $t('orderDetail.ShippingMethod') }}: {{ detailObj.orders.channelLevel }}</div>
        </div>
        <div class="f-c" v-if="false" style="height: 20px">
          <el-link type="warning" @click="detailVisit" v-if="detailObj.orders.platformCode !== 'KA'">{{ $t('orderDetail.IncomeStatement') }}</el-link>
        </div>
      </div>
      <div class="bottom f">
        <div style="flex: 1">
          <div class="productItemGroup bg-white" v-for="(item, index) in detailObj.orderLogistics" :key="index">
            <template v-if="item.omsPackId">
              <div class="shipping_soon" v-if="showStatus === 'waiting_to_ship'">
                <h3 style="margin-bottom: 16px">{{ $t('Order.Details.Index.ShippingSoon') }}</h3>
                <p style="color: #99C41C; font-size: 16px;margin-bottom: 4px;font-weight: 400;" v-if="item.items.some(e=>e.isOutOfStock === 1)">{{ $t('Order.Details.Index.Tips1') }}</p>
                <div class="f" style="margin-bottom: 10px">
                  <div class="code" style="margin-right: 30px;font-size: 14px;">{{ $t('Order.Details.Index.ParcelCode') }}: {{ item.omsPackId }}</div>
                  <div class="packStatus f--c">{{ item.packStatus }}</div>
                </div>

              </div>
              <div class="shippedInfomation" v-else>
                <div class="f-b" style="margin-bottom: 10px">
                  <h4 style="line-height: 36px">{{ $t('Order.Details.Index.LogisticsInformation') }}</h4>
                  <el-popconfirm
                    v-if="!['Cancelled', 'Completed'].includes(item.packStatus)"
                    :confirm-button-text="$t('Order.Details.Index.Confirm')"
                    :cancel-button-text="$t('Order.Details.Index.Cancel')"
                    icon="el-icon-info"
                    icon-color="red"
                    :title="$t('Order.Details.Index.ConfirmReceiptPrompt')"
                    @confirm="confirmReceipt(item)"
                  >
                    <el-button slot="reference" type="primary" round>{{ $t('Order.Details.Index.ConfirmReceipt') }}</el-button>
                  </el-popconfirm>
                  <div class="packStatis_complete f--c" v-else>{{ $t('Order.Details.Index.Completed') }}</div>
                </div>
                <div class="f-b-c" style="margin-bottom: 10px">
                  <div style="color: #747A87;flex: 1;">{{ $t('Order.Details.Index.DeliveryTime') }}: {{ getMoment(item.deliveryDate).format('YYYY-MM-DD HH:mm:ss') }}</div>
                  <div v-if="item.trackingCode || item.tailTrackingCode">
                    <div style="color: #99c41c;flex: 1;" @click="showTracking(item, 'trackingCode')" class="pointer" v-if="item.trackingCode">{{ $t('Order.Details.Index.TrackingCode') }}: {{ item.trackingCode }}</div>
                    <div style="color: #99c41c;flex: 1;" @click="showTracking(item, 'tailTrackingCode')" class="pointer" v-if="item.tailTrackingCode">{{ $t('Order.Details.Index.TailTrackingCode') }}: {{ item.tailTrackingCode }}</div>
                  </div>
                  <div class="f-c-c pointer" style="color: #99c41c;min-width: 140px;text-align: center;font-size: 14px;font-weight: 400;" v-else @click="showTracking(item)">{{ $t('Order.Details.Index.ShipmentTracking') }}</div>
                  <div style="color: #747A87;flex: 1;text-align: right;">{{ $t('Order.Details.Index.LogisticsProviders') }}: {{ item.logisticsProviders }}</div>
                </div>
                <div class="f" style="margin-bottom: 10px">
                  <div style="color: #747A87;margin-right: 30px">{{ $t('Order.Details.Index.ParcelCode') }}: {{ item.omsPackId }}</div>
                  <div class="f--c packStatus">{{ item.packStatus }}</div>
                </div>
              </div>
            </template>

            <template v-else>
              <h4 style="line-height: 36px">{{ $t('Order.Details.Index.ShippingSoon') }}</h4>
            </template>

            <!-- 商品列表 （不显示好评卡，固定在底部显示） -->
            <template v-for="product in item.items">
              <div v-if="product.type !== 'Cards'" class="productItem f-b" :key="product.skuCode">
                <div class="f">
                  <div style="min-width: 400px">
                    <div class="f" style="margin-bottom: 8px; font-size: 13px; color: #747a87">
                      <div style="margin-right: 8px">SKU：{{ product.skuCode }}</div>
                      <el-popover v-if="product.attachmentSkuVos && product.attachmentSkuVos.length && product.attachmentSkuVos.filter(t => t.type !== 'Cards').length" placement="bottom" width="360" trigger="hover">
                        <div class="partsTable">
                          <p>{{ $t('Order.Details.Index.Accessories') }}</p>
                          <template v-for="item in product.attachmentSkuVos">
                            <div v-if="item.type !== 'Cards'" :key="item.type+`_${item.id}`" class="f productBox">
                              <div class="imageBox">
                                <el-image :src="item.imageUrl" style="height: 52px; width: 52px"></el-image>
                              </div>
                              <div class="f-b fd-c info">
                                <p>{{ item.name }}</p>
                                <p>x {{ product.productNum }}</p>
                              </div>
                            </div>
                          </template>
                        </div>
                        <i class="icon-pinpaitemai-tianchong iconfont myAttachemtIcon" style="color: #99c41c; margin-right: 8px" slot="reference"></i>
                      </el-popover>
                      <div v-if="product.sellerSku && detailObj.orders.platformCode !== 'KA'">{{ $t('Order.Details.Index.StoreSKU') }}：{{ product.sellerSku }}</div>
                    </div>
                    <div class="f">
                      <div style="margin-right: 10px">
                        <el-popover placement="right" width="280" trigger="hover">
                          <el-image fit="cover" :src="product.imageUrl"></el-image>
                          <div style="position: relative; width: 70px; height: 70px; border-radius: 6px" slot="reference">
                            <el-image style="width: 70px; height: 70px; border-radius: 6px" :src="product.imageUrl" slot="reference"></el-image>
                            <div v-if="product.productType === 3"
                              style="position: absolute;
                              bottom: 8px;
                              background-color: #F7FCEB;
                              width: 100%;
                              height: 16px;
                              font-size: 12px;
                              line-height: 16px;
                              text-align:center;
                              color: #9AC331;">POD</div>
                            <div v-if="(product.isOutOfStock === 1 && !item.trackingCode) || (['waiting_payment','abnormal_order'].includes(detailObj.orders.status) && product.skuStatus !== 1)" class="f-c-c" style="width: 70px; height: 70px; position: absolute; left: 0; top: 0; background: rgba(0, 0, 0, 0.37); border-radius: 6px; color: #f2f2f2; font-size: 12px">Out of Stock</div>
                          </div>
                        </el-popover>
                      </div>
                      <div class="skuInfo">
                        <el-tooltip effect="dark" :content="product.productName" placement="top">
                          <div v-if="+detailObj.orders.orderType === 5" class="ellipsis" style="padding:0;line-height:20px;width: 260px;margin-bottom: 4px">{{ product.productName }}</div>
                          <el-button v-else type="text" class="ellipsis" style="padding:0;line-height:20px;width: 260px;margin-bottom: 4px" @click="jumpDetailSeo(product.kkProductId)">{{ product.productName }}</el-button>
                        </el-tooltip>
                        <template v-if="product.options_render && product.options_render.length > 40">
                          <el-tooltip effect="dark" :content="product.options_render" placement="top">
                            <div class="ellipsis" style="width: 260px; margin-bottom: 4px">{{ product.options_render }}</div>
                          </el-tooltip>
                        </template>
                        <p v-else style="margin-bottom: 4px">{{ product.options_render }}</p>
                        <div>
                          <span style="margin-right: 8px">US ${{ product.finalAmount }}</span>
                          <span v-if="product.price !== product.finalAmount" style="color: #747a87; font-size: 12px; text-decoration: line-through">${{ product.price }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="itemPrice f-c-c">
                    <span style="font-size: 14px; margin-right: 14px">X {{ product.productNum }}</span>
                    <span style="font-size: 16px">$ {{ (product.finalAmount * product.productNum).toFixed(2) | numberKeepTwoDecimal }}</span>
                  </div>
                </div>
                <div class="f fd-c" style="align-items: flex-end;">
                  <div style="padding-top: 6px;font-size:16px">{{ product.countryName }}</div>
                  <div v-if="product.refundStatus && product.refundStatus !== 'NULL'" class="refundStatus f--c" style="height: 14px;margin-top: 18px">{{ refundTextMap[product.refundStatus] }}</div>
                </div>
              </div>
            </template>
            <!-- 配件 好评卡 -->
            <template v-if="item.items.some(t => t.type === 'Cards')">
              <div v-for="product in item.items.filter(t => t.type === 'Cards')" class="productItem f-b" :key="product.skuCode">
                <div class="f">
                  <div style="min-width: 400px">
                    <div class="f" style="margin-bottom: 8px; font-size: 13px; color: #747a87">
                      <div style="margin-right: 8px">SKU：{{ product.skuCode }}</div>
                    </div>
                    <div class="f">
                      <div style="margin-right: 10px">
                        <el-popover placement="right" width="280" trigger="hover">
                          <el-image fit="cover" :src="product.imageUrl"></el-image>
                          <div style="position: relative; width: 70px; height: 70px; border-radius: 6px" slot="reference">
                            <el-image style="width: 70px; height: 70px; border-radius: 6px" :src="product.imageUrl" slot="reference"></el-image>
                          </div>
                        </el-popover>
                      </div>
                      <div class="skuInfo">
                        <el-tooltip effect="dark" :content="product.productName" placement="top">
                          <div style="margin-bottom:26px">{{ product.productName }}</div>
                        </el-tooltip>
                        <div>$0</div>
                      </div>
                    </div>
                  </div>
                  <div class="itemPrice f-c-c">
                    <span style="font-size: 14px; margin-right: 14px">X 1</span>
                  </div>
                </div>
              </div>
            </template>

            <div class="f-e weightTotal" style="line-height: 70px;font-size: 14px">
              <span>{{ $t('Order.Details.Index.Weight') }}:</span>
              <span>{{ packageWeight(item.items) | numberKeepTwoDecimal }}g</span>
            </div>
          </div>
        </div>
        <!-- Remark、Order status、Shipping Address -->
        <div class="productInfo">
          <div class="orderStatus bg-white" style="margin-bottom: 10px">
            <h3 style="margin-bottom: 20px; font-size: 18px">{{ $t('orderDetail.PaymentInformation') }}</h3>
            <h5 style="margin-bottom: 22px; font-size: 16px" v-if="['abnormal_order', 'waiting_payment', 'cancel'].includes(detailObj.orders.status)">{{ `-` }}</h5>
            <h5 style="margin-bottom: 22px; font-size: 16px" v-else class="f--c">
              {{ `${paymentMethodObjInternational} payment` }}
              <img class="pay-icon" src="@/assets/img/icon/paypal.png" v-if="+detailObj.pays.paymentMethod === 2" style="height: 22px" />
            </h5>
            <div class="f-b BalancePayment">
              <div>{{ $t('orderDetail.PaymentId') }}</div>
              <div>{{ detailObj.pays.paymentId || '-' }}</div>
            </div>
            <div class="f-b BalancePayment">
              <div>{{ $t('orderDetail.PaymentTime') }}</div>
              <div>{{ detailObj.times.payDate ? getMoment(detailObj.times.payDate).format('YYYY-MM-DD HH:mm:ss') : '-' }}</div>
            </div>
            <div class="f-b BalancePayment">
              <div>{{ $t('orderDetail.ItemSubtotal') }}</div>
              <div v-if="detailObj.pays.skusAmount">US${{ detailObj.pays.skusAmount | priceHandle }}</div>
              <div v-else>-</div>
            </div>
            <div class="f-b BalancePayment">
              <div>{{ $t('orderDetail.ShippingSubtotal') }}</div>
              <div v-if="detailObj.pays.freightAmount">US${{ detailObj.pays.freightAmount | priceHandle }}</div>
              <div v-else>-</div>
            </div>
            <div class="f-b BalancePayment">
              <div>{{ $t('orderDetail.Discount') }}</div>
              <div style="color: #eb5757" v-if="detailObj.pays.discountAmount">-US${{ detailObj.pays.discountAmount | priceHandle }}</div>
              <div v-else>-</div>
            </div>
            <!-- <div class="f-b BalancePayment">
              <div>{{ $t('orderDetail.promotion') }}</div>
              <div style="color: #eb5757" v-if="detailObj.pays.couponAmount">-US${{ detailObj.pays.couponAmount | priceHandle }}</div>
              <div v-else>-</div>
            </div> -->

            <!-- 优惠码金额 -->
            <div class="payment promo">
              <span class="payment-left">
                <span>Promo code</span>
                <el-popover placement="bottom" trigger="hover">
                  <p class="used-tips">{{ `Promo Code: ${promoCode.couponCode}` }}</p>
                  <div class="choose-to-use">
                    <i class="el-icon-s-ticket" />
                    <span class="get-info">
                      <strong class="get">{{ getOfferDisplayText }}</strong>
                      <span class="discount">{{ `${promoCode.discountRule === 1 ? `${promoCode.discountPercent && promoCode.discountPercent.toFixed(2)}% off` : `$${promoCode.discountFixed && promoCode.discountFixed.toFixed(2)}`}` }}</span>
                    </span>
                  </div>
                  <i v-show="promoCode.couponCode" slot="reference" class="el-icon-s-ticket" />
                </el-popover>
              </span>
              <span class="payment-right" :style="{ color: detailObj.pays.couponAmount ? '#EB5757' : '#333' }">- US${{ detailObj.pays.couponAmount | priceHandle }}</span>
            </div>

            <!-- 优惠券金额 -->
            <div class="payment promo">
              <span class="payment-left">
                <span>Coupon</span>
                <el-popover placement="bottom" trigger="hover">
                  <p class="used-tips">{{ `${coupon.id ? 1 : 0} coupon used` }}</p>
                  <CouponItem :coupon="coupon" isDetails class="coupon-item" />
                  <i v-show="coupon.id" slot="reference" class="el-icon-s-ticket" />
                </el-popover>
              </span>
              <span class="payment-right" :style="{ color: detailObj.pays.couponTicketAmount ? '#EB5757' : '#333' }">- US${{ detailObj.pays.couponTicketAmount | priceHandle }}</span>
            </div>

            <div class="f-b BalancePayment">
              <div>{{ $t('orderDetail.TotalAmount') }}</div>
              <div>US${{ detailObj.pays.totalAmount | priceHandle }}</div>
            </div>
            <div class="f-b BalancePayment">
              <div>{{ $t('orderDetail.PaymentAmount') }}</div>
              <div>US${{ detailObj.pays.finalAmount | priceHandle }}</div>
            </div>
          </div>
          <div class="remark bg-white" style="margin-bottom: 10px">
            <div class="f-b-c">
              <h3 style="font-size: 18px; margin-bottom: 10px">{{ $t('orderDetail.Note') }}</h3>
              <!-- 待付款状态的订单才展示备注编辑按钮 -->
              <el-button type="text" @click="showEdit" v-if="detailObj.orders.financialStatus === 'waiting'"><strong>{{ $t('orderDetail.Edit') }}</strong></el-button>
            </div>
            <!-- 没有备注时备注提示内容颜色置灰 -->
            <div class="right-note ellipsis" :style="{ color: detailObj.orders && detailObj.orders.remark ? '#606266' : '#ccc' }">
                {{  detailObj.orders && detailObj.orders.remark ? detailObj.orders.remark : $t('orderDetail.NoteTip') }}
            </div>
          </div>
          <div class="address bg-white">
            <h3>{{ $t('orderDetail.ShippingAddress') }}</h3>
            <p>{{ detailObj.address.recipient || '' }}</p>
            <p :class="{ redFont: !detailObj.address.phone }">{{ detailObj.address.phone || '?' }}</p>
            <p>
              <span :class="{ redFont: !detailObj.address.street1 }">{{ `${detailObj.address.street1 || '?'}` }}</span>
              <span>{{ `${detailObj.address.street2 || ''}` }}</span>
            </p>
            <p>
              <span :class="{ redFont: !detailObj.address.city }">{{ detailObj.address.city || '?' }}</span>
              <span>{{ detailObj.address.province }}</span>
              <span :class="{ redFont: !detailObj.address.country }">{{ detailObj.address.country || '?' }}</span>
            </p>
            <p :class="{ redFont: !detailObj.address.zip }">{{ detailObj.address.zip || '?' }}</p>
            <!-- <div class="f-c" v-if="addressIsWrong">
              <el-button v-if="detailObj.orders.notes && detailObj.orders.notes.code === 1" type="danger" round @click="updateAddressShow">{{ $t('Order.Details.Index.CompleteInformation') }}</el-button>
              <el-button v-else round @click="payNowClick">{{ $t('Order.Details.Components.TopTimeLine.GetLogistics') }}</el-button>
            </div> -->
          </div>
        </div>
      </div>
      <IncomeStatement :detailTableData="detailTableData" ref="IncomeStatement"></IncomeStatement>
    </div>
    <MTDetail v-else :product="detailObj" :promoCode="promoCode" :coupon="coupon" @payNow="payNowClick" @reFresh="orderGetDetail"></MTDetail>
    <pay-dialog ref="payDialog"></pay-dialog>
    <trackingDialog ref="trackingDialog"></trackingDialog>
    <AddressDialog ref="AddressDialog" :addForm="addressForm" @orderAddressChange="updateAddress" :isOrderAddress="true"></AddressDialog>
    <cancelRefundDialogVue ref="cancelRefundDialogVue" @reFresh="orderGetDetail"></cancelRefundDialogVue>
    <refundRecord ref="refundRecord"></refundRecord>
    <!-- 编辑备注内容提交后刷新页面订单数据 -->
    <order-note-edit ref="orderNoteEdit" @EditNoteSuccess="orderGetDetail"></order-note-edit>
  </div>
</template>

<script>
// import timeLineItem from '../../../components/common/timeLineItem'
import API from '@/api'
import PayDialog from '../list/components/payDialog.vue'
import IncomeStatement from './components/IncomeStatement.vue'
import MTDetail from './components/MTDetail.vue'
import trackingDialog from '../list/components/trackingDialog.vue'
import AddressDialog from '@/views/commodity/components/AddressDialog.vue'
import topTimeLine from './components/topTimeLine.vue'
import cancelRefundDialogVue from '../list/components/cancelRefundDialog.vue'
import moment from 'moment'
import { downloadBlobFile } from '@/util/index.js'
import refundRecord from './components/refundRecord.vue'
import OrderNoteEdit from './components/OrderNoteEdit.vue'

import CouponItem from '@/components/CouponItem.vue'

export default {
  components: { PayDialog, IncomeStatement, MTDetail, trackingDialog, AddressDialog, topTimeLine, cancelRefundDialogVue, refundRecord, CouponItem, OrderNoteEdit },
  data() {
    return {
      productItems: [],
      detailTableData: [],
      detailObj: {
        times: {
          purchaseDate: undefined,
          payAt: undefined,
          completedAt: undefined,
          cancelDate: undefined,
          refundDate: undefined
        },
        address: {
          country: '  ',
          city: '   ',
          phone: '   ',
          recipient: undefined,
          street1: '   ',
          street2: undefined,
          province: '   ',
          zip: '   ',
          vat: '   ',
          ioss: undefined
        },
        orders: {
          orderId: undefined,
          kkOrderId: undefined,
          platformCode: undefined,
          remark: undefined,
          orderStatus: undefined,
          operationType: undefined,
          channelCode: undefined,
          channelLevel: undefined,
          platformName: '',
          storeName: undefined,
          refundStatus: 'NULL'
        },
        pays: {
          finalAmount: undefined,
          freightAmount: undefined,
          skusAmount: undefined,
          taxes: undefined,
          paymentMethod: undefined
        },
        orderLogistics: [
          {
            deliveryTime: undefined,
            trackingCode: undefined,
            shipStatus: undefined,
            logisticsProviders: undefined,
            items: [
              {
                sizeImagePath: undefined,
                productName: undefined,
                productNum: undefined,
                skuCode: undefined,
                sellerSku: undefined,
                option1: undefined,
                option2: undefined,
                subtotal: undefined,
                purchasePrices: undefined
              }
            ]
          }
        ]
      },
      reasonText: '',
      orderStatus: 1, // 订单状态
      loading: false,
      remainingTime: 0, // 下单时间，做倒计时
      Interval: null,
      addressForm: {},
      kkOrderId: '',

      coupon: {}, // 优惠券

      promoCode: {} // 优惠码
    }
  },
  computed: {
    getOfferDisplayText() {
      switch (this.promoCode.discountCondition) {
        case 0: // 无门槛
          return `Get `
        case 1: // 消费满件数
          return `Spend `
        case 2: // 消费满金额
          return `Get `
        default:
          return '-'
      }
    },

    paymentMethodObjInternational() {
      const obj = { 0: this.$t('orderDetail.Balance'), 1: 'Airwallex', 2: 'Paypal', 3: 'Other payment Airwallex', 6: 'Credit', 8: '40Seas', 9: 'Payoneer' }
      if (this.detailObj.pays) {
        return obj[this.detailObj.pays.paymentMethod]
      }
      return '-'
    },
    addressIsWrong() {
      // return !['city', 'country', 'phone', 'street1', 'zip'].every((k) => this.detailObj.address[k])
      return this.detailObj.orders.status === 'abnormal_order'
    },
    showStatus() {
      if (['waiting_payment', 'completed', 'cancel', 'abnormal_order'].includes(this.detailObj.orders.status)) return this.detailObj.orders.status
      if (this.detailObj.orders.status === 'abnormal_order') return this.detailObj.orders.financialStatus
      if (this.detailObj.orders.status === 'processing') return this.detailObj.orders.fulfillmentStatus
      return 'NULL'
      /*
        waiting_payment 待支付
        completed 已完成
        cancel 已取消
        waiting_to_ship 待发货
        fully_shipped 已发货
        partial_shipped  部分发货
      */
    },
    getMoment() {
      return moment
    },
    refundText() {
      if (this.detailObj.orders.refundStatus !== 'NULL') {
        const statusMap = {
          refunding: 'Refunding',
          partial_refund: 'Partial Refund',
          refunded: 'Refunded'
        }
        return statusMap[this.detailObj.orders.refundStatus]
      }
      return ''
    },
    refundTextMap() {
      return {
        refunding: 'Refunding',
        partial_refund: 'Partial Refund',
        refunded: 'Refunded'
      }
    }
  },
  filters: {
    priceHandle(value) {
      if (value) return +value.toFixed(2)
      return '0.00'
    }
  },
  async created() {
    this.kkOrderId = this.$route.query.kkOrderId

    if (this.$route.query.couponCode) {
      // 链接内带有优惠码自动更新订单内的优惠码
      this.loading = true
      await API.updateOrdersCoupon({ couponCode: this.$route.query.couponCode }, this.kkOrderId)
    }
    this.orderGetDetail()
  },
  destroyed() {
    if (this.Interval) clearInterval(this.Interval)
  },
  methods: {

    /**
     * API 获取优惠券和优惠码详情
     *
     * @param {Object} parameter 请求参数
     */
    async getUserCouponTicketDetail(parameter) {
      let { data } = await API.getUserCouponTicketDetail(parameter)
      if (data) {
        this.coupon = data.couponTicket || {} // 优惠券
        this.promoCode = data.couponCode || {} // 优惠码
      }
    },

    detailVisit() {
      API.orderGetStatement(this.detailObj.orders.kkOrderId).then((res) => {
        this.detailTableData = res.data
        this.detailTableData.forEach((e) => {
          let options = JSON.parse(e.options)
          let options_render_str = ''
          for (let i = 0; i < options.length; i++) {
            let obj = JSON.parse(options[i])
            if (Object.prototype.toString.call(obj).slice(8, -1) === 'Object' && obj.value) options_render_str += `${obj.value}、`
          }
          options_render_str = options_render_str.slice(0, -1)
          this.$set(e, 'options_render_str', options_render_str)
        })
        this.$refs.IncomeStatement.show()
      })
    },
    orderGetDetail() {
      let kkOrderId = this.$route.query.kkOrderId
      this.loading = true
      API.orderGetDetail(kkOrderId)
        .then((res) => {
          if (res.code !== 10000) {
            this.$message.error(res.message)
            return
          }
          res.data.orderLogistics.forEach(item => {
            // 未发货按国家排序
            if (!item.items.omsPackId) {
              item.items.filter(t => t.type !== 'Cards').sort((x, y) => {
                return y.countryCode.localeCompare(x.countryCode)
              })
            }
          })
          this.detailObj = Object.assign(this.detailObj, res.data)
          let { pays } = this.detailObj
          if (pays) {
            this.getUserCouponTicketDetail({ userCouponTicketId: pays.couponTicketId, couponCode: pays.couponCode })
          }
          this.dataHandle()
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    payNowClick() {
      const { productName, productNum, skuCode: productSku } = this.detailObj.orderLogistics[0].items[0]
      const product = {
        kkOrderIds: [this.detailObj.orders.kkOrderId],
        storeGroup: this.detailObj.orders.storeGroup,
        totalAmount: this.detailObj.pays.totalAmount,
        platformCode: this.detailObj.orders.platformCode,
        productName,
        productNum,
        productSku,
        orderItems: this.detailObj.orderLogistics[0].items,
        ext: JSON.stringify(this.$route.query)
        // productName: this.detailObj.orders.productName,
        // productNum:
      }
      localStorage.setItem('product.kkOrderId', this.detailObj.orders.kkOrderId)
      if (this.isPC) {
        this.$refs.payDialog.show(product)
      } else {
        this.$refs.payDialog.MTShow({ product, isBatch: false })
      }
    },
    // 時間戳轉換
    timeToString(time) {
      let date = new Date(time)
      let minute = date.getMinutes().toString()
      let seconds = date.getSeconds().toString()
      let hours = date.getHours().toString()
      let month = (date.getMonth() + 1).toString()
      let day = date.getDate().toString()
      if (minute.length === 1) minute = `0${minute}`
      if (seconds.length === 1) seconds = `0${seconds}`
      if (hours.length === 1) hours = `0${hours}`
      if (month.length === 1) month = `0${month}`
      if (day.length === 1) day = `0${day}`
      return `${date.getFullYear()}-${month}-${day} ${hours}:${minute}:${seconds}`
    },
    remainingTimeCountDown() {
      this.remainingTime -= 200
      if (this.remainingTime < 0) {
        clearInterval(this.Interval)
        this.detailObj.orders.orderStatus = 1
      }
    },
    dataHandle() {
      this.detailObj.orderLogistics.forEach((e) => {
        if (e.deliveryTime) {
          this.$set(e, 'deliveryTime_render', this.timeToString(e.deliveryTime))
        }
        e.items.forEach((item) => {
          // 图片格式转换
          if (item.sizeImagePath && item.sizeImagePath.includes('[')) {
            let sizeImagePath = JSON.parse(item.sizeImagePath)
            let type = Object.prototype.toString.call(sizeImagePath).slice(8, -1)
            if (type === 'Array' && sizeImagePath.length) {
              item.sizeImagePath = sizeImagePath[0].imgUrl
            } else if (type === 'String') {
              item.sizeImagePath = sizeImagePath
            }
          }
          // 变体options转换
          let options_render = ''
          if (item.options) {
            const options = JSON.parse(item.options).map((e) => JSON.parse(e))
            options.forEach((e) => this.$set(item, e.name, e.value))
            JSON.parse(item.options).forEach((option) => {
              options_render += `${JSON.parse(option).value}、`
            })
            options_render = options_render.slice(0, -1)
            this.$set(item, 'options_render', options_render)
          }
        })
      })
      // 时间戳转换文本
      Object.keys(this.detailObj.times).forEach((key) => {
        // 根据时间戳转换时间
        if (typeof this.detailObj.times[key] === 'number') {
          this.$set(this.detailObj.times, `${key}_render`, this.timeToString(this.detailObj.times[key]))
        }
      })
      // 收货时间 取product里面第一个收货时间
      if (this.detailObj.orderLogistics[0].deliveryTime && typeof this.detailObj.orderLogistics[0].deliveryTime === 'number') {
        this.$set(this.detailObj.orderLogistics[0], 'deliveryTime_render', this.timeToString(this.detailObj.orderLogistics[0].deliveryTime))
      }
      // 退款原因 取消原因下拉
      // 取消  1 退款中  3  退款完成 4
      if ([1, 3, 4].includes(this.detailObj.orders.orderStatus)) {
        API.orderDropDownInfo({ type: 5 }).then((res) => {
          let target = res.data.find((e) => e.code === this.detailObj.orders.operationType || e.code === parseInt(this.detailObj.orders.operationType))
          if (target) this.reasonText = target.name
        })
      }
      // 待付款状态取出下单时间
      if (this.detailObj.orders.orderStatus === 0 && ['KA'].includes(this.detailObj.orders.platformCode)) {
        let startTime = this.detailObj.times.purchaseDate
        let endTime = startTime + 1000 * 60 * 60 * 24 * 5
        let currentTime = new Date().getTime()
        this.remainingTime = endTime - currentTime - 30000
        const that = this
        this.Interval = setInterval(() => {
          that.remainingTimeCountDown()
        }, 200)
      }
    },
    showTracking(item, code) {
      const params = {
        trackingNumber: item[code],
        omsPackId: item.omsPackId,
        carrierCode: item.logisticsProviders
      }
      this.$refs.trackingDialog.show(params)
    },
    updateAddress(addressForm) {
      const { countryCode: country, city, phoneNumber: phone, fullName: recipient, streetAddressLine1: street1, streetAddressLine2: street2, province, zipCode: zip } = addressForm
      const params = {
        data: {
          orderAddresses: {
            country,
            city,
            phone,
            recipient,
            street1,
            street2,
            province,
            zip
          },
          paymentMethod: 0
        },
        kkOrderId: this.kkOrderId
      }
      API.orderChangeAddress(params)
        .then((res) => {
          if (res.code !== 10000) return this.$message.error(res.message)
          this.$message.success(res.message)
          this.orderGetDetail()
          this.addressForm = {}
        })
        .catch((err) => {
          this.$message.error(err.data.data)
        })
    },
    updateAddressShow() {
      const { city, country: countryCode, phone: phoneNumber, province, street1: streetAddressLine1, street2: streetAddressLine2, zip: zipCode } = this.detailObj.address
      this.addressForm = { city, countryCode, phoneNumber, province, streetAddressLine1, streetAddressLine2, zipCode, fullName: this.detailObj.address.recipient }
      this.$refs.AddressDialog.show()
    },

    /**
     * 退款按钮的点击事件
     */
    handleRefund() {
      this.$router.push(`/order/refund?kakaOrderId=${this.$route.query.kkOrderId}`)
    },
    packageWeight(pack) {
      return pack
        .reduce((current, next) => {
          return current + (next.weight * next.productNum)
        }, 0)
        .toFixed(2)
    },
    cancelOrder() {
      this.$refs.cancelRefundDialogVue.show(this.detailObj.orders.kkOrderId)
    },
    orderDownloadInvoice() {
      API.orderDownloadInvoice(this.detailObj.orders.kkOrderId)
        .then((res) => {
          downloadBlobFile(res, `invoice.pdf`)
        })
        .catch((err) => {
          downloadBlobFile(err.data, `invoice.pdf`)
        })
    },
    confirmReceipt(packingBox) {
      API.orderReceipt(packingBox.omsPackId)
        .then((res) => {
          this.$message.success(res.message)
          this.orderGetDetail()
        })
        .catch((err) => {
          let message = err.message || err.data.message
          this.$message.error(message)
        })
    },
    // 更新详情
    updateDetail() {
      this.orderGetDetail()
    },

    // 打开编辑弹窗
    showEdit() {
      this.$refs.orderNoteEdit.show(this.kkOrderId, this.detailObj.orders.remark)
    }
  }
}
</script>

<style lang="scss" scoped>
.payment {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  .payment-left {
    color: #7d838f;
  }
  .payment-right {
    font-size: 16px;
    font-weight: 500;
  }
}

.used-tips {
  color: #8B93A3;
  margin-bottom: 5px;
}

.promo {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.choose-to-use {
  display: flex;
  width: 317px;
  height: 32px;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid #e3444e;
  background: rgba(227, 68, 78, 0.03);
  .icon-youhuiquan {
    color: #E3444E;
    font-size: 20px;
  }
  .get-info {
    margin-left: 5px;
    .get {
      color: #10141D;
    }
    .discount {
      color: #E3444E;
    }
  }
}

.el-icon-s-ticket {
  color: #E3444E;
  margin-left: 5px;
  cursor: pointer;
}

[v-cloak] {
  display: none;
}
.detailsContain {
  .middle {
    height: 24px;
    .id {
      div {
        margin-right: 50px;
        color: #747a87;
        font-size: 14px;
        height: 20px;
        line-height: 20px;
      }
    }
  }
  .bottom {
    .productItemGroup {
      min-width: 680px;
      padding: 15px 25px 0;
      // flex: 1;
      font-size: 18px;
      margin-right: 12px;
      margin-bottom: 10px;
      .productItem {
        height: 130px;
        padding-bottom: 10px;
        .skuInfo {
          font-size: 14px;
        }
        .itemPrice {
          position: relative;
          font-size: 16px;
          // font-weight: bold;
          > div {
            font-size: 12px;
            color: gray;
            text-decoration: line-through;
          }
        }
        .refundStatus::before{
          content: '';
          display: block;
          margin-right: 4px;
          width: 8px;
          height: 8px;
          line-height: 28px;
          border-radius: 100%;
          background-color: #e53353;
        }
        .refundStatus{
          color: #e53353;
          font-size: 14px;
          font-weight: 400;
        }
      }
      .weightTotal {
        height: 70px;
        line-height: 70px;
        border-top: 1px solid #cdd4dd;
      }
      .shipping_soon{
        h3{
          margin-bottom: 4px;
        }
        .info{
          margin-bottom: 4px;
          .code{
            font-size: 14px;
            color: #747A87;
            margin-right: 8px;
          }
        }
      }
      .packStatus{
        font-size: 14px;
        color: #99C41C;
      }
      .packStatus::before{
        content: '';
        display: block;
        margin-right: 4px;
        width: 8px;
        height: 8px;
        line-height: 28px;
        border-radius: 100%;
        background-color: #99C41C;
      }
      .shippedInfomation{
        margin-bottom: 20px;
        >div{
          >div{
            font-size: 14px;
            margin-right: 10px;
          }
        }
      }
      .packStatis_complete{
        background: #F0F3E9;
        border-radius: 30px;
        color: #99C41C;
        padding: 6px 20px;
      }
    }
    .productInfo {
      width: 360px;
      .remark {
        min-height: 100px;
        padding: 14px 25px;
      }
      .orderStatus {
        // height: 285px;
        padding: 22px;
        .BalancePayment {
          height: 24px;
          line-height: 24px;
          margin-bottom: 18px;
          > div:nth-of-type(1) {
            color: #747a87;
            font-size: 14px;
          }
          > div:nth-of-type(2) {
            font-size: 16px;
            font-weight: 500;
          }
        }
      }
      .address {
        // height: 180px;
        padding: 18px 20px;
        h3 {
          margin-bottom: 20px;
        }
        p {
          color: #8b93a3;
          font-size: 14px;
          // height: 20px;
          line-height: 20px;
          margin-bottom: 4px;
        }
        .redFont {
          color: #e53353;
        }
      }
    }
  }
  .refund_reason{
    margin-bottom: 12px;
    padding: 14px 30px 14px 60px;
  }
}
.comfirmReceiptDialog {
  padding: 10px 14px 0 14px;
  color: #99c41c;
  font-size: 18px;
}
.fontfine {
  /deep/span {
    font-weight: normal !important;
  }
}
.soldOutLabel {
  display: inline-block;
  width: 62px;
  height: 17px;
  font-weight: 400;
  font-size: 12px;
  text-align: center;
  line-height: 17px;
  color: #828282;
  background: #d9d9d9;
  border-radius: 2px;
}

.order-information {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 0;
  .handleGroup{
    >.el-button{
      margin-right: 6px;
    }
  }
  .myAttachemtIcon:hover {
    background-color: #f9fcf2;
  }
}
</style>
